import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function PoliticaReembolso() {
  return (
    <div className="min-h-screen bg-muted/30">
      <Header />
      <main className="max-w-4xl mx-auto px-4 pt-32 pb-16">
        <h1 className="text-3xl md:text-4xl font-bold font-display text-secondary mb-2">Política de Reembolso</h1>
        <p className="text-muted-foreground mb-10">Versão 2.0 — Última atualização: Março de 2026</p>

        <div className="bg-card rounded-2xl border border-border p-6 md:p-10 shadow-card space-y-8 text-foreground leading-relaxed">
          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">1. Visão Geral</h2>
            <p className="text-muted-foreground">O QuantoCustaObra possui duas modalidades de contratação, cada uma com regras de reembolso específicas: orçamento avulso (produto digital) e planos de assinatura.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">2. Orçamento Avulso — Produto Digital</h2>
            <p className="text-muted-foreground">O orçamento avulso é um produto digital entregue instantaneamente após a confirmação do pagamento. Sua natureza de bem digital com acesso imediato implica regras específicas de reembolso, conforme o Código de Defesa do Consumidor e o Decreto nº 7.962/2013.</p>

            <h3 className="font-semibold mt-4 mb-2">2.1 Situações de Reembolso</h3>
            <div className="overflow-x-auto mt-3">
              <table className="w-full text-sm border border-border rounded-xl overflow-hidden">
                <thead>
                  <tr className="bg-muted">
                    <th className="text-left py-3 px-4 font-semibold">Situação</th>
                    <th className="text-left py-3 px-4 font-semibold">Reembolso</th>
                    <th className="text-left py-3 px-4 font-semibold">Prazo</th>
                  </tr>
                </thead>
                <tbody className="text-muted-foreground">
                  <tr className="border-t border-border">
                    <td className="py-3 px-4">Orçamento não visualizado (até 7 dias)</td>
                    <td className="py-3 px-4 text-green-600 font-medium">100% — Integral</td>
                    <td className="py-3 px-4">Até 5 dias úteis</td>
                  </tr>
                  <tr className="border-t border-border">
                    <td className="py-3 px-4">Falha técnica comprovada</td>
                    <td className="py-3 px-4 text-green-600 font-medium">100% — Integral</td>
                    <td className="py-3 px-4">Até 5 dias úteis</td>
                  </tr>
                  <tr className="border-t border-border">
                    <td className="py-3 px-4">Cobrança duplicada</td>
                    <td className="py-3 px-4 text-green-600 font-medium">100% do valor duplicado</td>
                    <td className="py-3 px-4">Até 2 dias úteis</td>
                  </tr>
                  <tr className="border-t border-border">
                    <td className="py-3 px-4">Orçamento visualizado (produto consumido)</td>
                    <td className="py-3 px-4 text-destructive font-medium">Não há reembolso</td>
                    <td className="py-3 px-4">—</td>
                  </tr>
                  <tr className="border-t border-border">
                    <td className="py-3 px-4">Insatisfação com valores estimados</td>
                    <td className="py-3 px-4 text-destructive font-medium">Não há reembolso</td>
                    <td className="py-3 px-4">—</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h3 className="font-semibold mt-4 mb-2">2.2 Prova de Entrega</h3>
            <p className="text-muted-foreground">Para garantir transparência, o QuantoCustaObra registra automaticamente:</p>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Data e hora exata da geração do orçamento</li>
              <li>Data e hora de cada acesso/visualização</li>
              <li>Endereço IP do dispositivo utilizado</li>
              <li>Código único de identificação do orçamento</li>
              <li>Status de visualização (parcial ou completa)</li>
            </ul>
            <p className="mt-2 text-muted-foreground">Esses registros são mantidos por no mínimo 5 (cinco) anos e constituem prova de entrega do produto digital em eventuais disputas.</p>

            <h3 className="font-semibold mt-4 mb-2">2.3 Consentimento do Usuário</h3>
            <p className="text-muted-foreground">No momento da compra do orçamento avulso, o usuário obrigatoriamente marca a declaração de aceite. A compra não é processada sem esse aceite expresso.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">3. Planos de Assinatura</h2>

            <h3 className="font-semibold mt-4 mb-2">3.1 Cancelamento</h3>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>O cancelamento pode ser realizado a qualquer momento, sem multa ou burocracia</li>
              <li>Após o cancelamento, o acesso ao plano pago é mantido até o fim do período já pago</li>
              <li>Não há cobrança adicional após o cancelamento</li>
            </ul>

            <h3 className="font-semibold mt-4 mb-2">3.2 Reembolso de Assinatura</h3>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Não oferecemos reembolso proporcional de dias não utilizados dentro do ciclo de cobrança vigente</li>
              <li>O usuário tem acesso completo às funcionalidades do plano até o encerramento do período pago</li>
              <li>Após o término, a conta reverte automaticamente para o Plano Gratuito</li>
            </ul>

            <h3 className="font-semibold mt-4 mb-2">3.3 Exceção: Cobrança Duplicada</h3>
            <p className="text-muted-foreground">Em caso de cobrança duplicada comprovada: reembolso imediato do valor duplicado, processamento em até 2 dias úteis após identificação. O plano permanece ativo normalmente.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">4. Prazos de Reembolso</h2>
            <p className="text-muted-foreground">O reembolso será processado no mesmo meio de pagamento utilizado na compra original, salvo impossibilidade técnica (ex.: boleto vencido), caso em que será realizado via transferência bancária.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">5. Como Solicitar Reembolso</h2>
            <ol className="list-decimal pl-6 space-y-2 text-muted-foreground">
              <li>Envie email para <strong>contato@quantocustaobra.com.br</strong> com o assunto "Solicitação de Reembolso"</li>
              <li>No email, informe: nome completo, email cadastrado, código do orçamento ou nome do plano e motivo da solicitação</li>
              <li>Aguarde nossa análise — prazo de resposta: até 2 (dois) dias úteis</li>
              <li>Se aprovado, o reembolso será processado em até 5 (cinco) dias úteis com confirmação por email</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">6. Situações que Não Geram Reembolso</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Plano Gratuito (não há cobrança)</li>
              <li>Orçamento avulso já visualizado (produto digital consumido)</li>
              <li>Insatisfação com os valores estimados (os valores são estimativas baseadas em dados públicos; variações em relação à realidade não constituem defeito do produto)</li>
              <li>Uso comprovado de fraude, abuso ou violação dos Termos de Uso</li>
              <li>Compartilhamento não autorizado de orçamentos com terceiros</li>
              <li>Solicitações feitas após os prazos estabelecidos nesta política</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">7. Alteração de Plano</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li><strong>Upgrade (para plano superior):</strong> A diferença proporcional ao período restante será cobrada imediatamente. O acesso às novas funcionalidades é liberado na hora.</li>
              <li><strong>Downgrade (para plano inferior):</strong> Entra em vigor no próximo ciclo de cobrança. O usuário mantém o plano atual até o fim do período pago, sem reembolso proporcional.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">8. Disputas de Pagamento</h2>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Antes de abrir disputa na operadora de cartão (chargeback), entre em contato conosco. Nos comprometemos a resolver a situação em até 48 horas.</li>
              <li>Disputas abertas sem contato prévio conosco podem resultar em suspensão temporária da conta até a resolução.</li>
              <li>Mantemos registros detalhados de entrega (logs de acesso, aceite do usuário, IP) que serão apresentados à operadora em caso de disputa.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">9. Compromisso de Transparência</h2>
            <p className="text-muted-foreground">O QuantoCustaObra se compromete a:</p>
            <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
              <li>Apresentar claramente o preço e as condições antes de qualquer cobrança</li>
              <li>Exibir o aceite obrigatório de forma clara e destacada no fluxo de compra</li>
              <li>Manter registros acessíveis ao usuário sobre suas compras e visualizações</li>
              <li>Responder todas as solicitações de reembolso dentro do prazo de 2 dias úteis</li>
              <li>Processar reembolsos aprovados dentro de 5 dias úteis</li>
              <li>Comunicar qualquer alteração nesta política com antecedência mínima de 30 dias</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold font-display text-secondary mb-3">10. Contato</h2>
            <p className="text-muted-foreground">QuantoCustaObra Tecnologia Ltda.</p>
            <ul className="list-none space-y-1 text-muted-foreground mt-2">
              <li>Email geral: contato@quantocustaobra.com.br</li>
              <li>Financeiro: financeiro@quantocustaobra.com.br</li>
              <li>Privacidade: privacidade@quantocustaobra.com.br</li>
              <li>Site: quantocustaobra.com.br</li>
            </ul>
          </section>

          <div className="pt-4 border-t border-border">
            <p className="text-sm text-muted-foreground">
              Consulte também os nossos{' '}
              <Link to="/termos-de-uso" className="text-accent hover:underline">Termos de Uso</Link>.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PoliticaReembolso;
